import mixins from 'synergycms_core/src/less/mixins';

export default {
  currencyList: {},
  currenciesMoreInfo: {},
  defaultStyle: {
    display: 'none',
    position: 'fixed',
    left: '0',
    right: '0',
    top: '0',
    bottom: '100%',
    height: '100%',
    background: '#fff',
    zIndex: '600',
    overflow: 'auto',
    ...mixins.transition('bottom 1s'),
    '@media (min-width: 1001px)': {
      position: 'absolute',
      top: '100%',
      left: '0',
      right: '0',
      bottom: 'auto',
      overflow: 'hidden',
      zIndex: '400',
      height: 'auto',
      borderBottom: '1px solid #d8d8d8',
      borderTop: '1px solid #d8d8d8'
    }
  },
  selected: {
    ...mixins.transition('.5s'),
    display: 'block'
  },
  currencies: {
    textTransform: 'uppercase',
    width: '100%',
    textAlign: 'left',
    minHeight: '30px',
    padding: '5px',
    position: 'relative',
    '&$selected': {
      backgroundColor: '#f1f1f1'
    },
    '&:hover:not(.selected)': {
      ...mixins.transition(),
      borderBottom: data => '2px solid' + data.mainColor
    },
    '&:lang(ar)': {
      textAlign: 'right'
    }
  },

  currencyContainer: {
    maxWidth: '1250px',
    margin: '0 auto',
    position: 'relative',
    paddingTop: '19px',
    textAlign: 'left',
    '@global span': {
      fontFamily: data => data.fontFamily1
    },
    '& $currencyList': {
      padding: '8px 20px 26px',
      position: 'relative',
      '& > li': {
        display: 'inline-block',
        verticalAlign: 'top',
        width: 'calc(100% / 3 - 25px)',
        '&:not(:nth-of-type(9n + 9))': {
          '&:lang(ar)': {
            '@media(min-width:10500px)': {
              marginLeft: '30px',
              marginRight: '0'
            }
          },
          '@media(min-width:10500px)': {
            marginRight: '30px'
          }
        },
        '&:not(:nth-of-type(8n + 8))': {
          '&:lang(ar)': {
            '@media(min-width:1530px)': {
              marginLeft: '30px',
              marginRight: '0'
            },
            '@media(min-width:10500px)': {
              marginLeft: '0'
            }
          },
          '@media(min-width:1530px)': {
            marginRight: '30px'
          },
          '@media(min-width:10500px)': {
            marginRight: '0'
          }
        },
        '&:not(:nth-of-type(7n + 7))': {
          '&:lang(ar)': {
            '@media(min-width:1360px)': {
              marginLeft: '30px',
              marginRight: '0'
            },
            '@media(min-width:1530px)': {
              marginLeft: '0'
            }
          },
          '@media(min-width:1360px)': {
            marginRight: '30px'
          },
          '@media(min-width:1530px)': {
            marginRight: '0'
          }
        },
        '&:not(:nth-of-type(6n + 6))': {
          '&:lang(ar)': {
            '@media(min-width:1150px)': {
              marginLeft: '30px',
              marginRight: '0'
            },
            '@media(min-width:1360px)': {
              marginLeft: '0'
            }
          },
          '@media(min-width:1150px)': {
            marginRight: '30px'
          },
          '@media(min-width:1360px)': {
            marginRight: '0'
          }
        },
        '&:not(:nth-of-type(5n + 5))': {
          '&:lang(ar)': {
            '@media(min-width:670px)': {
              marginLeft: '30px',
              marginRight: '0'
            },
            '@media(min-width:1150px)': {
              marginLeft: '0'
            }
          },
          '@media(min-width:670px)': {
            marginRight: '30px'
          },
          '@media(min-width:1150px)': {
            marginRight: '0'
          }
        },
        '&:not(:nth-of-type(4n + 4))': {
          '&:lang(ar)': {
            '@media(min-width:500px)': {
              marginLeft: '30px'
            },
            '@media(min-width:670px)': {
              marginLeft: '0'
            }
          },
          '@media(min-width:500px)': {
            marginRight: '30px'
          },
          '@media(min-width:670px)': {
            marginRight: '0'
          }
        },
        '&:not(:nth-of-type(3n + 3))': {
          marginRight: '30px',
          '&:lang(ar)': {
            marginLeft: '30px',
            marginRight: 0,
            '@media(min-width:500px)': {
              marginLeft: 0
            }
          },
          '@media(min-width:500px)': {
            marginRight: '0'
          }
        },
        '@media(min-width:500px)': {
          width: 'calc(25% - 27px)'
        },
        '@media(min-width:670px)': {
          width: 'calc(20% - 30px)'
        },
        '@media(min-width:1150px)': {
          width: 'calc(100% / 6 - 30px)'
        },
        '@media(min-width:1360px)': {
          width: 'calc(100% / 7 - 30px)'
        },
        '@media(min-width:1530px)': {
          width: 'calc(100% / 8 - 30px)'
        },
        '@media(min-width:10500px)': {
          width: 'calc(100% / 9 - 32px)'
        }
      },
      '@media (min-width: 1001px)': {
        padding: '0 30px'
      }
    },
    '@media (min-width: 1001px)': {
      padding: '0 0 25px'
    },
    '&:lang(ar)': {
      textAlign: 'right',
      direction: 'rtl'
    }
  },
  titleContainer: {
    fontSize: '18px',
    position: 'relative',
    padding: '0 45px 0 20px',
    '@media (min-width: 1001px)': {
      padding: '17px 45px 17px 30px'
    },
    '&:lang(ar)': {
      paddingLeft: "45px",
      paddingRight: "20px",
      '@media (min-width: 1001px)': {
        paddingLeft: "45px",
        paddingRight: "30px"
      }
    }
  },
  filterHeaderTitle: {
    font: data => '18px ' + data.fontFamily2,
    display: 'inline'
  },
  currencyHeaderContainer: {
    position: 'relative',
    padding: '11px 45px 11px 20px',
    borderBottom: '1px solid #d8d8d8',
    textAlign: 'left',
    boxSizing:'border-box',
    '&:lang(ar)': {
      paddingLeft: "45px",
      paddingRight: "20px",
      textAlign: 'right',
    },
    '@global button': {
      position: 'absolute',
      top: '50%',
      right: '16px',
      height: '24px',
      width: '24px',
      marginTop: '-12px',
      color: data => data.mainColor,
      '&:lang(ar)': {
        right: 'auto',
        left: '16px'
      }
    },
    '@media (min-width: 1001px)': {
      borderBottom: 'none',
      paddingBottom: '0',
      paddingTop: '0',
      maxWidth: '1250px',
      margin: '0 auto'
    },
    '& $currenciesMoreInfo': {
      fill: data => data.mainColor,
      width: '20px',
      height: '20px',
      display: 'inline-block',
      verticalAlign: 'middle',
      marginLeft: '5px',
      position: 'relative',
      bottom: '2px',
      '@media (min-width: 1001px)': {
        position: 'absolute',
        top: '18px',
        right: '30px',
        zIndex: '1'
      },
      '&:lang(ar)': {
        marginLeft: "0",
        marginRight: "5px",
        '@media (min-width: 1001px)': {
          right: 'auto',
          left: '30px'
        }
      }
    }
  },
  currencyFilterTooltip: {
    textAlign: 'left',
    position: 'absolute',
    width: '70%',
    display: 'table',
    backgroundColor: '#fc0',
    font: data => '12px ' + data.fontFamily1,
    color: '#333',
    padding: '20px 10px',
    zIndex: '700',
    '@media(min-width:1001px)': {
      fontSize: '13px',
      width: '25%'
    },
    '&:lang(ar)': {
      textAlign: 'right'
    }
  },
  currencyFilterPopover: {
    height: '10%',
    width: '10%',
    display: 'table-row'
  },
  closeTextBtn:{
    '& span':{
      pointerEvents: 'none',
    }
  }
};
